import LEGOArt from "../containers/MosaicArtMaker"
import Layout from "../components/layout"
import React from "react"
import SEO from "../components/seo"
import { graphql } from "gatsby"
type LegoArtPageProps = {}

const LegoArtPage: React.FunctionComponent<LegoArtPageProps> = props => {
    // const { data } = props;

  return (
    <Layout>
      <SEO
        title="Mosaic Art Maker || Create LEGO diagrams for your needs!"
        description="Change any photo to a mosaic LEGO clipart that could be used to build custom portraits and images."
      />
      <LEGOArt />
    </Layout>
  )
}

export default LegoArtPage;